import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteComboComponent } from './autocomplete-combo/autocomplete-combo.component';
import { CoreModule } from '@app/core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartialsModule } from '@app/views/partials/partials.module';
import { MatAutocompleteModule, MatFormFieldModule, MatIconModule, MatInputModule } from '@angular/material';



/**
 * dsadsa
 */
@NgModule({
  declarations: [AutocompleteComboComponent],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
  

    MatFormFieldModule,
    MatIconModule,
    MatAutocompleteModule,
    FormsModule,
		ReactiveFormsModule,
		MatInputModule,

  
   
  ],
  exports: [
    AutocompleteComboComponent
  ]
})
export class CommonComponentModule { }
